__webpack_require__.p = "/securedmessagecenter/";